import { isNull } from 'lodash';

export default (firstName, lastName) => {
  const isFirstNameExist = !isNull(firstName);
  const isLastNameExist = !isNull(lastName);

  return `${isFirstNameExist ? firstName : ''} ${isLastNameExist ? lastName : ''}`.trim();
};
